exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.search-icon {\r\n    pointer-events: none;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/app/components/controls/search-box.component.css
// module id = 660
// module chunks = 0